import React, { useState } from 'react';
import styled, { css } from 'styled-components';
const StyledToggle = styled.div `
  width: ${({ theme }) => theme.style.toggleWidth};
  height: ${({ theme }) => theme.style.toggleHeight};
  user-select: none;
  border-radius: ${({ theme }) => theme.style.toggleBorderRadius};
  cursor: pointer;
  background: var(--toggle-background, ${({ theme }) => theme.style.toggleBackgroundColor});
  transition: background-color 0.2s, box-shadow 0.2s;
  position: relative;
  box-shadow: var(--toggle-shadow),
    var(--toggle-border-properties) var(--toggle-border-width) var(--toggle-border-color),
    0 0 0 var(--toggle-outline, 0px) var(--toggle-outline-color, transparent);

  --toggle-border-properties: ${({ theme }) => theme.style.toggleBorderProperties};
  --toggle-border-width: ${({ theme }) => theme.style.toggleBorderWidth};
  --toggle-border-color: ${({ theme }) => theme.style.toggleBorderColor};
  --toggle-border-color: ${({ theme, isHovered }) => isHovered && theme.style.toggleHoveredBorderColor};
  --toggle-border-color: ${({ theme, isFocussed }) => isFocussed && theme.style.toggleFocussedBorderColor};

  --toggle-background: ${({ theme, isHovered }) => isHovered && theme.style.toggleHoveredBackgroundColor};
  --toggle-background: ${({ theme, isFocussed }) => isFocussed && theme.style.toggleFocussedBackgroundColor};

  --toggle-shadow: ${({ theme }) => theme.style.toggleShadow};

  --toggle-outline: ${({ theme, isFocussed }) => isFocussed && theme.style.toggleFocussedOutline};
  --toggle-outline-color: ${({ theme, isFocussed }) => isFocussed && theme.style.toggleFocussedOutlineColor};

  cursor: ${({ isDisabled }) => isDisabled && 'not-allowed'};
  opacity: ${({ isDisabled }) => isDisabled && 0.5};

  ${({ isChecked }) => isChecked &&
    css `
      --toggle-x: ${({ theme }) => `${parseInt(theme.style.toggleWidth ?? '0', 10) -
        parseInt(theme.style.toggleHandleSize ?? '0', 10) -
        parseInt(theme.style.toggleHandleSpacing ?? '0', 10) * 2}px`};
      --toggle-easing: ${({ theme }) => theme.style.toggleEasing};
      --toggle-duration: ${({ theme }) => theme.style.toggleDuration};
      --toggle-handle: ${({ theme }) => theme.primary.foreground};

      --toggle-background: ${({ theme }) => theme.style.toggleCheckedBackgroundColor};
      --toggle-background: ${({ theme, isHovered }) => isHovered && theme.style.toggleCheckedHoveredBackgroundColor};
      --toggle-border-properties: ${({ theme }) => theme.style.toggleCheckedBorderProperties};
      --toggle-border-width: ${({ theme }) => theme.style.toggleCheckedBorderWidth};
      --toggle-border-color: ${({ theme }) => theme.style.toggleCheckedBorderColor};
      --toggle-outline-color: ${({ theme, isFocussed }) => isFocussed && theme.style.toggleCheckedFocussedOutlineColor};
    `}

  &:after {
    content: '';
    display: block;
    left: ${({ theme }) => theme.style.toggleHandleSpacing};
    top: ${({ theme }) => theme.style.toggleHandleSpacing};
    border-radius: ${({ theme }) => theme.style.toggleHandleBorderRadius};
    width: ${({ theme }) => theme.style.toggleHandleSize};
    height: ${({ theme }) => theme.style.toggleHandleSize};
    position: absolute;
    box-shadow: ${({ theme }) => theme.style.toggleHandleShadow};
    background-color: var(--toggle-handle, ${({ theme }) => theme.style.toggleHandleBackgroundColor});
    transform: translateX(var(--toggle-x, 0)) scale(1);
    transition: background-color 0.2s, width var(--toggle-duration, 0.2s) var(--toggle-easing, ease),
      transform var(--toggle-duration, 0.2s) var(--toggle-easing, ease);
  }

  &:active {
    &:after {
      content: '';
      width: calc(${({ theme }) => theme.style.toggleHandleSize} + 4px);
      transform: translateX(calc(var(--toggle-x, 0) - 4px));
    }
  }
`;
export const Toggle = (props) => {
    const [isHoveredState, setIsHoveredState] = useState(false);
    const [isFocussedState, setIsFocussedState] = useState(false);
    const [isPressedState, setIsPressedState] = useState(false);
    const styleProps = {
        isChecked: props.isChecked ?? false,
        isHovered: props.isHovered ?? isHoveredState,
        isFocussed: props.isFocussed ?? isFocussedState,
        isPressed: props.isPressed ?? isPressedState,
        isDisabled: props.isDisabled ?? false,
    };
    const handleHoverChange = (value) => {
        if (props.onHoverChange && value !== isHoveredState) {
            props.onHoverChange(value);
        }
        setIsHoveredState(value);
    };
    const handleFocusChange = (value) => {
        if (props.isDisabled) {
            return;
        }
        if (props.onFocusChange && value !== isFocussedState) {
            props.onFocusChange(value);
        }
        setIsFocussedState(value);
    };
    const handlePressChange = (value) => {
        if (props.onPressChange && value !== isPressedState) {
            props.onPressChange(value);
        }
        if (value) {
            handleFocusChange(true);
        }
        setIsPressedState(value);
    };
    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (props.isDisabled) {
            return;
        }
        const isChecked = !(props.isChecked ?? false);
        if (props.onCheckedChange && props.isChecked !== isChecked) {
            props.onCheckedChange(isChecked);
        }
        handleFocusChange(false);
        handlePressChange(false);
    };
    return (React.createElement(StyledToggle, { className: props.className, style: props.style, onClick: handleClick, onMouseEnter: () => handleHoverChange(true), onMouseMove: () => handleHoverChange(true), onMouseLeave: () => handleHoverChange(false), onFocus: () => handleFocusChange(true), onBlur: () => handleFocusChange(false), onMouseDown: (e) => {
            e.preventDefault();
            e.stopPropagation();
            handlePressChange(true);
        }, onMouseUp: () => handlePressChange(false), ...styleProps }));
};
//# sourceMappingURL=Toggle.js.map